'use client';

import { c as _c } from "react/compiler-runtime";
import { InfoTooltip } from '@cc-shopping/ui/composites/InfoTooltip';
import { Box } from '@mui/material';
import { SummaryTableRatingText } from '../SummaryTableRatingText';
import { useSummaryTableHeaderTooltipPageAction } from './hooks';
import { RatingTitleDriverGroupImprovements } from './RatingTitleDriverGroupImprovements';
export function RatingTitle(t0) {
  const $ = _c(9);
  const {
    segmentActionSection,
    isRewardsOrSubprimeRU: t1
  } = t0;
  const isRewardsOrSubprimeRU = t1 === undefined ? false : t1;
  const handleTooltipClickPageAction = useSummaryTableHeaderTooltipPageAction();
  if (isRewardsOrSubprimeRU) {
    let t2;
    if ($[0] !== handleTooltipClickPageAction || $[1] !== segmentActionSection) {
      t2 = <RatingTitleDriverGroupImprovements handleTooltipClickPageAction={handleTooltipClickPageAction} segmentActionSection={segmentActionSection} />;
      $[0] = handleTooltipClickPageAction;
      $[1] = segmentActionSection;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      whiteSpace: "nowrap"
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      marginLeft: 1
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SummaryTableRatingText />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== handleTooltipClickPageAction || $[7] !== segmentActionSection) {
    t5 = <Box display="flex" alignItems="center" sx={t2}>NerdWallet rating<Box display="flex" alignItems="center" sx={t3}><InfoTooltip position="bottom" text={t4} ariaLabel="How are NerdWallet's ratings determined?" maxWidth="19.375rem" onOpen={() => handleTooltipClickPageAction("open", segmentActionSection)} onClose={() => handleTooltipClickPageAction("close", segmentActionSection)} onBlur={() => handleTooltipClickPageAction("close", segmentActionSection)} /></Box></Box>;
    $[6] = handleTooltipClickPageAction;
    $[7] = segmentActionSection;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}